var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"editor"}},[_c('div',{ref:"editor",attrs:{"className":"textNeirong"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }